import { render } from "./TrayMenuItem.vue?vue&type=template&id=2da4e386&scoped=true"
import script from "./TrayMenuItem.vue?vue&type=script&lang=js"
export * from "./TrayMenuItem.vue?vue&type=script&lang=js"

import "./TrayMenuItem.vue?vue&type=style&index=0&id=2da4e386&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da4e386"]])

export default __exports__